import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    cate = '',
    dstType = '',
    dstId = '',
    layers = 3,
    refKpiId = '',
    content = {},
}, options = { showError: true }) => {
    const [ res, error, status ] = await POST(URLS.kpi.kpiStorage.create, {
        cate,
        dstType,
        dstId,
        layers,
        refKpiId,
        content,
    }, options);
    if (error) return { error, status };
    return res || { };
};
